import React from "react";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import { getLatestDateFromData } from "../../../Utils/utils";
import Loader from "../../../components/Loader";

const ComprehensiveGuidelinesTab = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const {
    data: citizensCharterData = [],
    isLoading: citizensCharterIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "comprehensive-guideline",
    lang: languageType,
  });

  console.log({ citizensCharterData });

  const lastUpdatedOn = getLatestDateFromData(citizensCharterData);

  //   if (citizensCharterIsLoading) {
  //     return <Loader />;
  //   }
  return (
    <div className="container">
      <div className="row mb-5">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 mvDescWrap">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <div className="table-responsive">
              <table className="table table-striped custom-table">
                <thead className="thead-dark">
                  <tr>
                    <th>{getText("S.No", "क्र.सं.")}</th>
                    <th>{getText("Title", "शीर्षक")}</th>
                    <th>{getText("Open PDF", "पीडीएफ देखें")}</th>
                  </tr>
                </thead>
                <tbody>
                  {citizensCharterData.map((item, index) => (
                    <tr key={index}>
                      <td data-key={getText("S.No.", "क्र. सं.")}>
                        {index + 1}
                      </td>
                      <td
                        className="no-wrap-td"
                        data-key={getText("Particulars", "विवरण")}
                      >
                        {item.title}
                      </td>
                      <td data-key={getText("View", "देखें")}>
                        <a
                          href={`${process.env.REACT_APP_IMAGE_URL}${item.field_download}`}
                          title={item.title}
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "blue",
                          }}
                        >
                          {getText("More »", "अधिक »")}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
    </div>
  );
};

export default ComprehensiveGuidelinesTab;
